import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {PageService} from "../../models/PageService";
import { EnvironmentService } from 'src/app/services/environment.service';

@Injectable({
  providedIn: 'root'})
export class PageServiceService {

private menuVisibilityStateSubject = new BehaviorSubject<{ [menu: string]: boolean }>({});
menuVisibility$ = this.menuVisibilityStateSubject.asObservable();

getMenuVisibility(menuName: string): boolean {
  return this.menuVisibilityStateSubject.value[menuName] || false;
}

setAllMenuVisibility(newVisibilityState: { [menu: string]: boolean }): void {
  this.menuVisibilityStateSubject.next(newVisibilityState);
} 

  BASE_URL = '/ws/rest';
  PAGE_SERVICE = '/pageService';
  ADHESION_INDIVIDUELLE_ENDPOINT = "/ws/rest/adhesion_individuelles"
  getListContrat(): Observable<any> {
    return this.http.get<any>(this.environmentService.get().serverUrl + this.ADHESION_INDIVIDUELLE_ENDPOINT
      + "/portail/contrats" + "/list");

  }

  constructor(private readonly http: HttpClient, private environmentService: EnvironmentService) {}
  getPageServiceList(): Observable<any> {
    return this.http.get<any>(this.environmentService.get().serverUrl + this.BASE_URL + this.PAGE_SERVICE + '/getPageServices');
  }

  getPageServiceById(id:number): Observable<PageService> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id);
    return this.http.get<PageService>(this.environmentService.get().serverUrl + this.BASE_URL + this.PAGE_SERVICE + '/getPageServiceById', { params: queryParams });
  }

  getRouting() : Observable<any>{
    return this.http.get<any>(this.environmentService.get().serverUrl + this.BASE_URL + '/gestion_menu/get_routing');
  }

}
